var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"large-scatter"},[_c('ChartScatter',{attrs:{"height":"250","width":"700","chartData":_vm.points_filtered,"render_info":{
                  display_extra: false,
                  background_color_scale: 0
                }},on:{"dotClicked":function($event){return _vm.dotClicked($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"medium-scatter"},[_c('ChartScatter',{attrs:{"height":"250","width":"400","chartData":_vm.points_filtered,"render_info":{
                  display_extra: false,
                  background_color_scale: 0
                }},on:{"dotClicked":function($event){return _vm.dotClicked($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }